import { gql } from '@apollo/client';

/**
 * Detailed classroom query for full classroom list view
 * Optimized to only include fields actually used by ClassesListsSection
 */
export const GET_CLASSROOMS_DETAIL_LIST = gql`
  query SkWeb_Classrooms_7(
    $schoolId: ID
    $page: Int
    $pageSize: Int
    $sortBy: String
    $order: String
    $name: String
  ) {
    classroomList(
      schoolId: $schoolId
      page: $page
      pageSize: $pageSize
      sortBy: $sortBy
      order: $order
      name: $name
    ) {
      data {
        id
        name
        school {
          id
          name
        }
        courses {
          level
          product {
            id
            name
            baseLevel
            levels
            isCustomLevel
            customLevels
          }
        }
        teachers {
          id
          name
          username
        }
        studentsLength
      }
      totalCount
    }
  }
`;
